/* ============================================================================
   Nova Adult Hockey — design system entry point
   ============================================================================
   Import order is load-bearing:

     1. tokens      colour, type, space, radius, elevation, motion. Dark mode
                    keys off `.ion-palette-dark` on <html> (the class name is
                    kept from the Ionic era; the theme store toggles it).
     2. base        document defaults, typography, focus, reduced motion.
     3. ui          the in-house component kit (replaces ionic.css).
     4. primitives  the shared class vocabulary and the spacing safety net.
                    Last, so a primitive can override a component default.
   ========================================================================= */

@import "./tokens.css";
@import "./base.css";
@import "../ui/ui.css";
@import "./primitives.css";
@import "./embed-shell.css";
